const { doc } = require('prettier');

if (document.querySelector('.main-product')) {
  if (document.querySelector('.main-product').getAttribute('data-is-poster') == 'true') {
    const selectedVariant = findSelectedVariant();
    const selectedVariantPrice = convertToNumber(selectedVariant.price);
    const selectedSize = selectedVariant.name;

    togglPassepartoutVariants(selectedSize);

    const variants = document.querySelectorAll('.product-variant__item--radio input[type="radio"]');
    for (const variant of variants) {
      variant.addEventListener('click', updatePrice);
    }
    preloadFramesAndPassepartoutImages();
  }
}

function updatePrice(e) {
  const selectedVariant = findSelectedVariant();
  const selectedVariantPrice = convertToNumber(selectedVariant.price);
  const selectedSize = selectedVariant.name;

  togglPassepartoutVariants(selectedSize);

  const selectedFrameSize = findFrameSize(selectedSize);
  const selectedFrame = findSelectedFrame(selectedFrameSize);
  const selectedFramePrice = selectedFrame ? convertToNumber(selectedFrame.price) : 0;

  const selectedPassepartoutPrice = findSelectedPassepartoutPrice(selectedSize);

  const totalPrice = selectedVariantPrice + selectedFramePrice + selectedPassepartoutPrice;
  const priceElement = document.querySelector('#product-price-container .money');
  const currencyText = document.querySelector('.main-product').getAttribute('data-currency');

  setPassepartoutLabelText(selectedSize);
  setGalleryImages();

  updateBtnPrice(totalPrice, currencyText, priceElement);

  updateBtnPrice(totalPrice, currencyText, document.querySelector('#add-to-cart-button .money'));
  updateBtnPrice(totalPrice, currencyText, document.querySelector('#sticky-add-to-cart-button .money'));
}

function updateBtnPrice(totalPrice, currencyText, priceElement) {
  if (priceElement) {
    const buttonText = priceElement.textContent;

    const pricePattern = /\b\d{1,3}(?:[.,\s]?\d{3})*(?:[.,]\d{2})?\b/;
    const currentPriceMatch = buttonText.match(pricePattern);

    if (currentPriceMatch && currentPriceMatch[0] !== "00") {
      const currentPrice = currentPriceMatch[0];
      const usesCommaForThousands = /,\d{3}/.test(currentPrice);
      const usesDotForThousands = /\.\d{3}/.test(currentPrice);
      const usesSpaceForThousands = /\s\d{3}/.test(currentPrice);
      const usesCommaAsDecimal = currentPrice.includes(',') && currentPrice.indexOf(',') > currentPrice.indexOf('.');

      const numericNewPrice = parseFloat(totalPrice.toString().replace(/[.,\s](?=\d{3})/g, ''));

      const hasDecimals = currentPrice.includes(',') || currentPrice.includes('.');

      let newFormattedPrice;
      if (usesCommaForThousands) {
        newFormattedPrice = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: hasDecimals ? 2 : 0
        }).format(numericNewPrice);
      } else if (usesDotForThousands) {
        newFormattedPrice = new Intl.NumberFormat("de-DE", {
          minimumFractionDigits: hasDecimals ? 2 : 0
        }).format(numericNewPrice);
      } else if (usesSpaceForThousands) {
        newFormattedPrice = new Intl.NumberFormat("fr-FR", {
          minimumFractionDigits: hasDecimals ? 2 : 0
        }).format(numericNewPrice);
      } else {
        if (currentPrice % 1 === 0) {
          newFormattedPrice = numericNewPrice.toFixed(0);
        } else {
          newFormattedPrice = numericNewPrice.toFixed(2).replace('.', usesCommaAsDecimal ? ',' : '.');
        }
      }
      const updatedText = buttonText.replace(pricePattern, newFormattedPrice);
      priceElement.textContent = updatedText;
    }
  }
}

function findSelectedVariant() {
  const selectedVariantElement = document.querySelector(`input.product-variant__input:checked`);

  const selectedVariantData = variantData.find((variant) => {
    return variant.name === selectedVariantElement.value;
  });

  return selectedVariantData;
}

function togglPassepartoutVariants(selectedSize) {
  const convertedSize = selectedSize.replace(/\s*cm\s*/g, '').replace(/\s*x\s*/g, 'x');

  const selectedPassepartout = passepartoutData.find((product) => {
    return product.variants.some((variant) => {
      return variant.title.includes(`(Window: ${convertedSize})`);
    });
  });

  if (!selectedPassepartout) {
    document.querySelector('.passepartouts .product-variant__container').style.display = 'none';
    document.getElementById('passepartout-not-found').style.display = 'block';
    document.querySelector('#selected-passepartout .selected-name').innerText = '';
    document.querySelector('#selected-passepartout .add-on-price').innerText = '';
  } else {
    document.querySelector('.passepartouts .product-variant__container').style.display = 'block';
    document.getElementById('passepartout-not-found').style.display = 'none';
  }
}

function findFrameSize(selectedSize) {
  const { selectedPassepartoutVariant } = findSelectedPassePartout(selectedSize);

  if (!selectedPassepartoutVariant) {
    return selectedSize;
  }

  return selectedPassepartoutVariant.title?.split('(')[0]?.trim();
}

function findSelectedFrame(selectedSize) {
  const selectedFrameElement = document.querySelector(`input[name="product-frame"]:checked`);
  const selectedFrameProductId = selectedFrameElement.value;
  const noneSelectedTranslationString = document.getElementById('selected-frame').getAttribute('data-none-selected-translation-string');

  const selectedFrame = frameData.find((product) => {
    return product.product_id === selectedFrameProductId;
  });

  let selectedFrameVariant = selectedFrame?.variants.find((variant) => {
    return variant.title === selectedSize;
  });

  if (!selectedFrameVariant && selectedFrame) {
    const posterSize = selectedSize.replace(" ", "").replace("cm", "");
    const posterSide1 = parseFloat(posterSize.split('x')[0]?.replace(",", "."));
    const posterSide2 = parseFloat(posterSize.split('x')[1]?.replace(",", "."));
    let posterHeight;
    let posterWidth;
    const orientation = selectedFrame.orientation;

    if (orientation == 'portræt') {
      posterHeight = posterSide1 < posterSide2 ? posterSide2 : posterSide1;
      posterWidth = posterSide1 > posterSide2 ? posterSide2 : posterSide1
    } else {
      posterHeight = posterSide1 > posterSide2 ? posterSide2 : posterSide1;
      posterWidth = posterSide1 < posterSide2 ? posterSide2 : posterSide1
    }

    selectedFrame.variants.forEach(variant => {
      if (variant.title.includes('range:')) {
        const frameRange1 = variant.title.replace(" ", "").replace("cm", "").replace("range:", "").split("x")[0];
        const frameRange2 = variant.title.replace(" ", "").replace("cm", "").replace("range:", "").split("x")[1];
        const frameRange1Min = parseFloat(frameRange1.split("-")[0]?.replace(",", "."));
        const frameRange1Max = parseFloat(frameRange1.split("-")[1] ? frameRange1.split("-")[1].replace(",", ".") : frameRange1.split("-")[0]?.replace(",", "."));
        const frameRange2Min = parseFloat(frameRange2.split("-")[0]?.replace(",", "."));
        const frameRange2Max = parseFloat(frameRange2.split("-")[1] ? frameRange2.split("-")[1]?.replace(",", ".") : frameRange2.split("-")[0]?.replace(",", "."));
        let frameHeightMin;
        let frameHeightMax;
        let frameWidthMin;
        let frameWidthMax;

        if (orientation == 'portræt') {
          frameHeightMin = frameRange1Min < frameRange2Min ? frameRange2Min : frameRange1Min;
          frameHeightMax = frameRange1Min < frameRange2Min ? frameRange2Max : frameRange1Max;
          frameWidthMin = frameRange1Min > frameRange2Min ? frameRange2Min : frameRange1Min;
          frameWidthMax = frameRange1Min > frameRange2Min ? frameRange2Max : frameRange1Max;
        } else {
          frameHeightMin = frameRange1Min > frameRange2Min ? frameRange2Min : frameRange1Min;
          frameHeightMax = frameRange1Min > frameRange2Min ? frameRange2Max : frameRange1Max;
          frameWidthMin = frameRange1Min < frameRange2Min ? frameRange2Min : frameRange1Min;
          frameWidthMax = frameRange1Min < frameRange2Min ? frameRange2Max : frameRange1Max;
        }

        if (posterHeight >= frameHeightMin && posterHeight <= frameHeightMax && posterWidth >= frameWidthMin && posterWidth <= frameWidthMax) {
          selectedFrameVariant = variant;
        }
      }
    })
  }

  if (selectedFrameVariant) {
    document.querySelector('#selected-frame .selected-name').innerText = `${selectedFrame?.product_title}`;
    document.querySelector('#selected-frame .add-on-price').innerText = `+${selectedFrameVariant.price}`;
    return selectedFrameVariant;
  }

  document.querySelector('#selected-frame .selected-name').innerText = noneSelectedTranslationString;
  document.querySelector('#selected-frame .add-on-price').innerText = '';
  return;
}

function preloadFramesAndPassepartoutImages() {
  let image_list = [];
  frameData.forEach(function (frame) {
    const newImage = new Image();
    newImage.src = frame.image;
    image_list.push(newImage);
  });
  passepartoutData.forEach(function (passepartout) {
    const newImage = new Image();
    newImage.src = passepartout.image;
    image_list.push(newImage);
  });
}

function setGalleryImages() {
  const selectedPassepartoutElement = document.querySelector(`input[name="product-passepartout"]:checked`);
  const selectedFrameElement = document.querySelector(`input[name="product-frame"]:checked`);
  const firstGalleryImage = document.querySelector('.product-gallery-item:first-of-type');

  if (selectedFrameElement.value != '') {
    const selectedFrameProductId = selectedFrameElement.value;
    const selectedFrame = frameData.find((product) => {
      return product.product_id === selectedFrameProductId;
    });
    const frameImage = selectedFrame?.image;
    if (frameImage != 'no_image') {
      firstGalleryImage.style.setProperty('--frame-image', 'url(' + frameImage + ')');
    } else {
      firstGalleryImage.style.setProperty('--frame-image', '');
    }
  } else {
    firstGalleryImage.style.setProperty('--frame-image', '');
  }

  if (selectedPassepartoutElement.value != '' && document.querySelector('.passepartout').parentElement.style.display != 'none') {
    const selectedPassepartoutProductId = selectedPassepartoutElement.value;
    const selectedPassepartout = passepartoutData.find((product) => {
      return product.product_id === selectedPassepartoutProductId;
    });
    const passepartoutImage = selectedPassepartout?.image;

    if (passepartoutImage != 'no_image') {
      firstGalleryImage.style.setProperty('--passepartout-image', 'url(' + passepartoutImage + ')');
      firstGalleryImage.classList.add('has-passepartout');
    } else {
      firstGalleryImage.style.setProperty('--passepartout-image', '');
      firstGalleryImage.classList.remove('has-passepartout');
    }
  } else {
    firstGalleryImage.style.setProperty('--passepartout-image', '');
    firstGalleryImage.classList.remove('has-passepartout');
  }
}

function findSelectedPassePartout(selectedSize) {
  const selectedPassepartoutElement = document.querySelector(`input[name="product-passepartout"]:checked`);
  const selectedPassepartoutProductId = selectedPassepartoutElement.value;

  const selectedPassepartout = passepartoutData.find((product) => {
    return product.product_id === selectedPassepartoutProductId;
  });

  //adjusting string to match format on passepartout variant
  const convertedSize = selectedSize.replace(/\s*cm\s*/g, '').replace(/\s*x\s*/g, 'x');

  const selectedPassepartoutVariant = selectedPassepartout?.variants.find((variant) => {
    return variant.title.includes(`(Window: ${convertedSize})`);
  });

  return { selectedPassepartout, selectedPassepartoutVariant };
}

function findSelectedPassepartoutPrice(selectedSize) {
  const { selectedPassepartout, selectedPassepartoutVariant } = findSelectedPassePartout(selectedSize);

  if (selectedPassepartoutVariant) {
    return convertToNumber(selectedPassepartoutVariant.price);
  }

  return 0;
}

function setPassepartoutLabelText(selectedSize) {
  const { selectedPassepartout, selectedPassepartoutVariant } = findSelectedPassePartout(selectedSize);
  const noneSelectedTranslationString = document.getElementById('selected-passepartout').getAttribute('data-none-selected-translation-string');
  if (selectedPassepartoutVariant) {
    document.querySelector('#selected-passepartout .selected-name').innerText = `${selectedPassepartout?.product_title}`;
    document.querySelector('#selected-passepartout .add-on-price').innerText = `+${selectedPassepartoutVariant.price}`;
  } else {
    document.querySelector('#selected-passepartout .add-on-price').innerText = '';

    if (document.querySelector('#passepartout-not-found').style.display == 'block') {
      document.querySelector('#selected-passepartout .selected-name').style.display = 'none';
    } else {
      document.querySelector('#selected-passepartout .selected-name').innerText = noneSelectedTranslationString;
    }
  }
}

function convertToNumber(str) {
  if (!str) return 0;
  //return parseFloat(str.replace(/\./g, '').replace(',', '.'));
  return parseFloat(str.replace(/[,](?=\d{3})|[.](?=\d{3})/g, '').replace(/[,|.](?=\d{2}$)/, '.'));
}

const addToCartButton = document.getElementById('add-to-cart-button');

if (addToCartButton) addToCartButton.addEventListener('click', addToCart);

async function addToCart() {
  const items = [];
  if (document.querySelector('.main-product').getAttribute('data-is-poster') == 'true') {
    const bundleID = Math.ceil(Math.random() * 100000);
    const selectedVariant = findSelectedVariant();
    const selectedSize = selectedVariant.name;
    const passepartoutAvailable = document.querySelector("#passepartout-not-found").style.display == "none" ? true : false;
    const selectedFrameSize = findFrameSize(selectedSize);
    const selectedFrame = findSelectedFrame(selectedFrameSize);
    const { selectedPassepartout, selectedPassepartoutVariant } = findSelectedPassePartout(selectedSize);

    items.push(
      {
        id: selectedVariant.id,
        quantity: 1,
        properties: { _bundle_id: bundleID },
      }
    )

    if (selectedFrame && selectedFrame.variant_id) {
      items.push({
        id: selectedFrame.variant_id,
        quantity: 1,
        properties: { _bundle_id: bundleID },
      });
    }

    if (selectedPassepartoutVariant && selectedPassepartoutVariant.variant_id) {
      items.push({
        id: selectedPassepartoutVariant.variant_id,
        quantity: 1,
        properties: { _bundle_id: bundleID },
      });
    }
    
  } else if (document.querySelector('.main-product').getAttribute('data-bundle-product-ids') != "") {
    const variants = document.querySelector('.main-product').getAttribute('data-bundle-product-ids');
    const bundleID = document.querySelector(".main-product .product__title").innerText;
    variants?.split(',').forEach(variant => {
      const variantID = variant.split("[")[0];
      const variantQTY = parseInt(variant.split("[")[1].replace("]", ""));
      items.push(
        {
          id: variantID,
          quantity: variantQTY,
          properties: { _b2b_package: bundleID },
        }
      )
    })
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    openCart();
    console.log('Item added to cart:', data);
  } catch {
    console.log('error adding to cart');
  }
}

function openCart() {
  if (!document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay') {
    window.refreshCart();
    document.getElementById('site-cart-sidebar').show();
    if (document.getElementById('cart-recommendations-sidebar')) {
      document.getElementById('cart-recommendations-sidebar').generateRecommendations();
    }
    setTimeout(() => {
      document.querySelector('#site-cart-sidebar [data-js-close]').focus();
    }, 200);
  }
}
